import React from 'react';

import classNames from 'classnames/bind';
import style from './DesktopHeader.scss';
const ctx = classNames.bind(style);

import Spreader from '../../../Spreader';

class DesktopHeader extends React.Component {
  render() {
    const { title, description } = this.props;

    return (
      <div className={ctx('header-container')}>
        <div
          className={ctx('background')}
          style={{ backgroundImage: `url(${'images/header-bg.jpg'})` }}
        />
        <div className={ctx('inner')}>
          <div className={ctx('header')}>
            <div className={ctx('top-logo')}>
              <div className={ctx('gals')}>
                <img src={'images/gals_logo.svg'} width="257px" height="74px" />
              </div>
            </div>
            <div className={ctx('title')}>{title}</div>
            <Spreader>
              <div className={ctx('tagline')}>
                <div className={ctx('match-point')}>
                  <img
                    src={'images/MatchPoint_logo.svg'}
                    width="156px"
                    height="110px"
                  />
                </div>
                <div className={ctx('description')}>{description}</div>
              </div>
            </Spreader>
          </div>
          <div className={ctx('bottom-logo')}>
            <span className={ctx('logo')}>
              <img
                src={'images/kommersant_logo.png'}
                width="276px"
                height="32px"
              />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default DesktopHeader;
